// Third party packages
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
import * as i3 from "../../shared/services/config.service";
var PermissionsService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function PermissionsService(apiService, helperService, configService) {
        this.apiService = apiService;
        this.helperService = helperService;
        this.configService = configService;
        this.moduleTypes = this.configService.availableModules;
    }
    /**
     * Create a new permission
     *
     * @since 1.0.0
     *
     * @param permission Permission data
     * @returns Observable<any>
     */
    PermissionsService.prototype.create = function (permission) {
        return this.apiService.apiCall("POST", "permissions", permission, undefined, undefined, undefined, "v2");
    };
    /**
     * Get permissions list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    PermissionsService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "permissions", params, undefined, undefined, undefined, "v2");
    };
    /**
     * Get an exportation file of all permissions
     *
     * @since 1.0.0
     */
    PermissionsService.prototype.getExport = function () {
        var _this = this;
        return this.apiService
            .apiCall("GET", "permissions/export", {}, { responseType: "blob" }, undefined, undefined, "v2")
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get given permissionId data from back-end
     *
     * @since 1.0.0
     *
     * @param permissionId ID of the permission to get
     */
    PermissionsService.prototype.get = function (permissionId) {
        var _this = this;
        return this.apiService
            .apiCall("GET", "permissions/" + permissionId, undefined, undefined, undefined, undefined, "v2")
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Update permission with given permissionId with given permission data
     *
     * @since 1.0.0
     *
     * @param permissionId ID of permission to update
     * @param data New permission's data
     */
    PermissionsService.prototype.update = function (permissionId, data) {
        return this.apiService.apiCall("PUT", "permissions/" + permissionId, data, undefined, undefined, undefined, "v2");
    };
    /**
     * Delete permanently a permission
     *
     * @since 1.0.0
     *
     * @param permissionId ID of the permission
     */
    PermissionsService.prototype.delete = function (permissionId) {
        return this.apiService.apiCall("DELETE", "permissions/" + permissionId, undefined, undefined, undefined, undefined, "v2");
    };
    PermissionsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PermissionsService_Factory() { return new PermissionsService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService), i0.ɵɵinject(i3.ConfigService)); }, token: PermissionsService, providedIn: "root" });
    return PermissionsService;
}());
export { PermissionsService };
